﻿const { getConfig } = require("@cirrus/config")

const CustomerInfo = Backbone.Model.extend({
  initialize() {
    this.url = this.urlRoot.replace("{0}", getConfig().Customer)
  },
  urlRoot: Url.api("/api/v1/customer/{0}/info"),
})

const customerInfo = new CustomerInfo()

customerInfo.fetch({
  async: false,
  error(collection, response, options) {
    if (response.status === 404) {
      window.location.href = "/site-entry"
    } else {
      window.location.href = "/500"
    }
  },
})

export default customerInfo
